module.exports = __webpack_public_path__ + "img/EU.8a82ad9c.svg";